import { MatchingStationery } from './MatchingStationery';
export default MatchingStationery;
